export default __webpack_public_path__ + "static/media/ScanSurgeryFIll.b1e4a9fd.svg";